
import { firmware, hwVersion, image, lastSeen, manufacturer, name } from '~/helpers/fields-description';
import { MullerModule } from '~/models/modules/muller/MullerModule.model';

export class NMR extends MullerModule {
    manufacturer_id?: string;
    image_type?: string;

    get fieldName() {
        return name(this.name);
    }
    get fieldFirmware() {
        return firmware(this.firmware);
    }
    get fieldLastSeen() {
        return lastSeen(this.last_seen, this.outdatedLastSeen ? 'error--text' : '');
    }
    get fieldHwVersion() {
        return hwVersion(this.hw_version);
    }
    get fieldManufacturer() {
        return manufacturer(this.manufacturer_id);
    }
    get fieldImage() {
        return image(this.image_type);
    }
}
